import React from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';

import useTimezone from '../../hooks/useTimezone';
import config from '../../config/config';

const TimeSlot = ({
  timeSlot,
  selected=false,
  disabled=false,
  color='primary',
  outlined=false,
  onClick=(e, val) => console.log('val', val),
}) => {
  const timezone = useTimezone() || moment.tz.guess();
  const {start_time} = timeSlot;
  const displayTime = moment.tz(start_time, timezone).format('h:mm A');
  return (
    <Box
      key={timeSlot}
      onClick={e => onClick(e, timeSlot)}
      sx={{
        px: 2,
        py: 0.75,
        width: '95px',
        borderRadius: config().styles.defaultRadius,
        cursor: disabled ? 'default' : 'pointer',
        userSelect: 'none',
        border: (
          selected 
          ? `0.5px solid ${config().colors[color || 'primary']}` 
          : (outlined ? `0.5px solid ${config().colors[color || 'primary']}` : config().styles.defaultBorder)
        ),
        bgcolor: selected ? config().colors[color || 'primary'] : '#fff',
        color: selected ? '#fff' : 'text.primary',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.15s ease',
        '&:hover': disabled ? {} : {
          bgcolor: selected ? config().colors[color || 'primary'] : 'grey.100',
        },
      }}
    >
      {displayTime}
    </Box>
  );
};

export default TimeSlot;